// ==================================================================================
// SHOPIFY PIXEL EVENT TRIGGER SCRIPT (replaces Google Ads gtag)
// ==================================================================================

const STORE_ID = 'themessycorner.myshopify.com';   // e.g. 'my-store.myshopify.com'
const CURRENCY = 'INR';

function generateEventId() {
  return `EVENT-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

function buildEmitter() {
  return {
    platform: 'shopify',
    channel: 'web',
    app: 'juspay',
    store_id: STORE_ID
  };
}

function publishShopifyPixelEvent(eventName, payload) {
  try {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(eventName, payload);
    } else {
      // console.warn('⚠️ Shopify.analytics.publish unavailable; skipping:', eventName);
    }
  } catch (e) {
    // console.error('❌ Error publishing Shopify pixel event:', e);
  }
}

// ==================================================================================
// PURCHASE
// ==================================================================================

window.addEventListener("breeze-purchase", (event) => {
  if (!event.detail?.data) {
    // console.error("❌ Purchase event: Invalid event data");
    return;
  }

  try {
    const params = event.detail.data;
    const orderId = params.shopOrderId || params.platformIdentifierId || params.sessionId;
    const dedupeKey = 'breeze_purchase_sent_' + orderId;

    if (orderId && localStorage.getItem(dedupeKey)) {
      console.warn('⚠️ Purchase event already fired for order, skipping:', orderId);
      return;
    }

    publishShopifyPixelEvent('simprosys:purchase', buildPurchasePayload(params));
    console.log("purchase done")

    if (orderId) {
      localStorage.setItem(dedupeKey, '1');
    }
  } catch (e) {
    console.error("❌ Error in breeze-purchase handler:", e);
  }
});

function buildPurchasePayload(params) {
  const items = mapItems(params.items);
  const subTotal = items.reduce((sum, i) => sum + i.price * i.quantity, 0);

  return {
    event_type: 'purchase',
    emitter: buildEmitter(),
    event_id: generateEventId(),
    transaction_id: params.shopOrderId,
    sub_total_value: params.totalPrice,
    total_value: subTotal,
    currency: CURRENCY,
    tax: params.tax || 0,
    shipping: params.shippingCharge || 0,
    coupon: params.coupon || params.discountCode || '',
    discount_value: params.discountValue || 0,
    customer_id: params.customerId || '',
    customer_type: params.customerType,
    payment_type: params.paymentMethodType,
    user_data: buildUserData(params.userDetails, params.billingDetails, params.customerId),
    items
  };
}

// ==================================================================================
// BEGIN CHECKOUT
// ==================================================================================

window.addEventListener("breeze-initiate-checkout", (event) => {
  if (!event.detail?.data) {
    console.error("❌ Checkout event: Invalid event data");
    return;
  }
  try {
    publishShopifyPixelEvent('simprosys:begin_checkout', buildBeginCheckoutPayload(event.detail.data));
    // console.log("begin checkout done");
    
  } catch (e) {
    console.error("❌ Error in breeze-initiate-checkout handler:", e);
  }
});

function buildBeginCheckoutPayload(params) {
  const items = mapItems(params.items);
  const subTotal = items.reduce((sum, i) => sum + i.price * i.quantity, 0);

  return {
    event_type: 'begin_checkout',
    emitter: buildEmitter(),
    event_id: generateEventId(),
    sub_total_value: params.totalPrice,
    total_value: subTotal,
    currency: CURRENCY,
    coupon: params.coupon || params.discountCode || '',
    discount_value: params.discountValue || 0,
    customer_id: params.customerId || '',
    user_data: buildUserData(params.userDetails, null, params.customerId),
    items
  };
}

// ==================================================================================
// ADD PAYMENT INFO
// ==================================================================================

window.addEventListener("breeze-add-payment-info", (event) => {
  if (!event.detail?.data) {
    console.error("❌ Add payment info event: Invalid event data");
    return;
  }
  try {
    publishShopifyPixelEvent('simprosys:add_payment_info', buildAddPaymentInfoPayload(event.detail.data));
    
  } catch (e) {
    console.error("❌ Error in breeze-add-payment-info handler:", e);
  }
});

function buildAddPaymentInfoPayload(params) {
  const items = mapItems(params.items);
  const subTotal = items.reduce((sum, i) => sum + i.price * i.quantity, 0);

  return {
    event_type: 'add_payment_info',
    emitter: buildEmitter(),
    event_id: generateEventId(),
    sub_total_value: params.totalPrice,
    total_value: subTotal,
    currency: CURRENCY,
    coupon: params.coupon || params.discountCode || '',
    discount_value: params.discountValue || 0,
    customer_id: params.customerId || '',
    payment_type: params.paymentMethodType,
    user_data: buildUserData(params.userDetails, null, params.customerId),
    items
  };
}

// ==================================================================================
// UTILITIES
// ==================================================================================

function mapItems(items) {
  if (!Array.isArray(items)) {
    // console.error("❌ mapItems: invalid items array:", items);
    return [];
  }
  return items.map(item => ({
    product_id: String(item.id),
    sku: item.sku || '',
    variant_id: item.variant != null ? String(item.variant) : '',
    item_name: item.name,
    item_brand: item.vendor,
    item_category: item.productType,
    item_variant: item.variantTitle || null,
    price: item.price,
    quantity: item.quantity,
    coupon: item.coupon || '',
    discount: item.discount || 0,
    google_business_vertical: 'retail',
    promotion_id: item.promotionId || '',
    promotion_name: item.promotionName || ''
  }));
}

function mapAddress(addr) {
  if (!addr) return null;
  return {
    first_name: addr.firstName || addr.name || '',
    last_name: addr.lastName || '',
    street: addr.address || addr.street || '',
    city: addr.city || '',
    region: addr.state || addr.region || '',
    postal_code: addr.postalCode || '',
    country: addr.country || 'IN'
  };
}

function buildUserData(userData, billingData, customerId) {
  if (!userData) return null;

  const shipping = mapAddress(userData);
  const billing = mapAddress(billingData) || mapAddress(userData.billingAddress) || shipping;

  return {
    user_id: customerId || userData.userId || userData.customerId || '',
    email: userData.email || '',
    phone_number: userData.phone || '',
    shipping_address: shipping,
    billing_address: billing
  };
}